import React from "react";
import HStack from "@components/layout/HStack";

type Props = {
  icon: React.ReactNode;
  label: string;
};
const TitleSetting = ({ icon, label }: Props) => {
  return (
    <HStack gap={2}>
      {icon}
      {/* <img src={icon} alt={label} className="w-5 h-5" /> */}
      <p className="text-sm font-semibold">{label}</p>
    </HStack>
  );
};

export default TitleSetting;
